"use strict";
const { object, string } = require('../../utils/modifiedYup');
const { rawContentSchema, displayComponentContentSchema, formComponentContentSchema, templateContentSchema, builderContentSchema, } = require('./contentSchema');
const webLinkSchema = object().shape({
    type: string().oneOf(['web']).required(),
    content: object()
        .oneOfSchemas([
        rawContentSchema,
        // Web Link schema allows only display components
        // ie. Text, Banner
        displayComponentContentSchema,
        templateContentSchema,
        builderContentSchema,
    ])
        .required(),
});
const webFormSchema = object().shape({
    type: string().oneOf(['web']).required(),
    content: object()
        .oneOfSchemas([
        rawContentSchema,
        // Web Form schema allows both display and form components
        // ie. Text, FormTextField, SubmitButton
        formComponentContentSchema,
        templateContentSchema,
        builderContentSchema,
    ])
        .required(),
});
module.exports = {
    webLinkSchema,
    webFormSchema,
};
//# sourceMappingURL=linkSchema.js.map